import ProductCard from "./ProductCard";
import {Link} from "react-router-dom";
import {RightArrow} from "./common/RightArrow";
import {useTranslation} from "react-i18next";
import {product_cards} from "../data/data";

function ProductSection() {
    const { t } = useTranslation();
    return (
        <div className="section bg-primary-light-color">
            <h1 data-aos="fade-right"
                data-aos-duration="300"
                className="subtitle">{t('home_product_header')}</h1>
            <p>{t('home_product_subtitle')}</p>
            <div className="max-md:flex-col flex gap-4 place-content-center mt-4 mx-8 max-sm:mx-0 max-w-screen-lg">
                {product_cards.map((product, index) => (
                    <ProductCard key={index} link={product.link} img={product.image} title={t(product.title)} content={t(product.content)} />
                ))}
            </div>
            <Link to="/product/cotton">
                <div className="flex bg-primary text-white mt-12 px-4 py-2 rounded space-x-2 shadow-sm">
                    <div className="text-2xl font-bold">{t('general_see_all_product')}</div>
                    <RightArrow color="text-white"/>
                </div>
            </Link>
        </div>
    );
}

export default ProductSection;